import { axiosApi } from './helper'


export function getInterstitials(obj) {
    return axiosApi('interstitials', obj, 'get')
}

export function seenInterstitial(id) {
    return axiosApi(`interstitials/${id}/seen`, {}, 'post')
}

export function closedInterstitial(id) {
    return axiosApi(`interstitials/${id}/closed`, {}, 'post')
}